<template>
  <v-app-bar
    elevation="0"
    class="main-header"
    height="64"
    fixed
    color='primary'
    dark>
    <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-menu</v-icon>
      </template>
    </v-btn>
    <!-- <v-toolbar-title :class="$vuetify.theme.dark ? 'primary--text' : null">Cabinet Ais24</v-toolbar-title> -->
    
    <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :loading="!IS_LOAD_WORK_SPACE"
          large
          outlined
          rounded
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{SHORT_NAME_WORK_SPACE}}
        </v-btn>
      </template>
      <workspaces-list></workspaces-list>
    </v-menu>
    <v-menu
      ref="orgMenu"
      bottom
      origin="center center"
      transition="scale-transition"
      v-model="menuOrganizations"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :loading="!IS_LOAD_WORK_SPACE || ORGANIZATION_IS_FETCHING"
          class="mx-2"
          large
          outlined
          rounded
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ORGANIZATION_SHORT_NAME}}
        </v-btn>
      </template>
      <v-list  
        style="max-height: 400px; overflow-y:auto"
        offset-y 
        v-if="$route.name !== 'Organizations' || ORGANIZATIONS.length > 0"
      >
        <v-list-item v-if="ORGANIZATIONS.length > 2">
            <v-text-field
                label="Поиск"
                solo
                dense
                v-model="orgSearch"
            ></v-text-field>
        </v-list-item>
        <v-list-item
            link
            v-for="(organizationHistory, i) in menuOrganizationItems"
            :key="i"
            @click="onCheckoutOrganization(organizationHistory.id)"
        >
          <v-list-item-title>
              <v-icon
                v-if="ORGANIZATION_ID === organizationHistory.id"
                large
                color="green darken-2"
              >
                mdi-check-bold
              </v-icon>
              {{ organizationHistory.short_name }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!HAS_LOAD_MORE" link @click="() => $router.push({name: 'OrganizationAdd'}) && $refs.orgMenu.save()">
            <v-list-item-icon>
                <v-icon color="green" >mdi-plus-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Добавить</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="HAS_LOAD_PREV || HAS_LOAD_MORE">
          <v-btn
            v-if="HAS_LOAD_PREV"
            class="ma-2"
            color="indigo"
            dark
            @click="LOAD_PREV"
          >
            <v-icon dark>
              mdi-skip-previous
            </v-icon>
          </v-btn>
          <v-btn
            v-if="HAS_LOAD_MORE"
            @click="LOAD_MORE"
            :right="true" :absolute="true"
            class="ma-2"
            color="indigo"
            dark
          >
            <v-icon dark>
              mdi-skip-next
            </v-icon>
          </v-btn>
        </v-list-item>
    <v-overlay :value="IS_FETCHING">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      </v-list>
    </v-menu>
    <v-spacer></v-spacer>
    <!-- <Search /> -->

    <v-menu
      offset-y
      bottom
      nudge-bottom="10"
      left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="notificationsBadge ? notificationsBadge = !notificationsBadge : ''"
          v-bind="attrs"
          v-on="on"
          icon
          class="mr-2">
          <v-badge
            :value="NOTIFICATIONS_COUNT > 0 ? notificationsBadge : false"
            color="error"
            :content="NOTIFICATIONS_COUNT"
            overlap>
            <v-icon
              size="28"
              :color="config.light.iconColor"
            >mdi-bell-outline</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in NOTIFICATIONS_LIST"
            :key="i"
          >
            <v-list-item-icon class="mr-4 mb-1">
              <v-icon
                :color="item.color"
                v-text="item.icon"
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <div class="greeting-text mr-3 d-none d-md-block">
      <v-btn
        icon
        :color="config.light.iconColor"
        @click="() => this.$router.push({name: 'SuportPage'})"
      >
        <v-icon>mdi-face-agent</v-icon>
      </v-btn>
    </div>
    <v-menu
      min-width="180"
      offset-y
      bottom
      left
      nudge-bottom="10"
    >
      <template v-slot:activator="{ on, attrs }">
<!--        <div class="greeting-text mr-3 d-none d-md-block"-->
<!--          v-bind="attrs"-->
<!--          v-on="on"-->
<!--        >-->
<!--          <span>{{USER_NAME}}</span>-->
<!--        </div>-->
        <avatar
            v-bind="attrs"
            v-on="on">
        </avatar>
<!--        <v-avatar v-if="AVATAR"-->
<!--          size="40"-->
<!--          v-bind="attrs"-->
<!--          v-on="on"-->
<!--          class="mr-2">-->
<!--          <img :src="ACTUAL_AVATAR">-->
<!--        </v-avatar>-->
<!--        <v-avatar v-else-->
<!--          size="40"-->
<!--          v-bind="attrs"-->
<!--          v-on="on"-->
<!--          class="mr-2">-->
<!--          <img src="@/assets/img/user/avatars/account-avatar.png">-->
<!--        </v-avatar>-->

      </template>
      <v-list >
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">{{USER_FULL_NAME}}</div>
        <!-- <div class="subtitle-2 primary--text font-weight-regular px-4">Flatlogic.com</div> -->
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in account"
            :key="i"
            :to="{name: item.route}"
          >
            <v-list-item-icon class="mr-4">
              <v-icon
                :color="item.color"
                v-text="item.icon"
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title color="greyTint" v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

    </v-menu>

    <!-- <div class="greeting-text mr-3 d-none d-md-block"><span>{{USER_NAME}}</span></div> -->
    <div class="greeting-text mr-3 d-none d-md-block"><span>            
      <v-btn
        width="80%"
        large
        outlined
        class="text-capitalize"
        @click="logoutUser">Выйти</v-btn>
      </span>
    </div>

  </v-app-bar>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  import config from '../../config';
  // import Search from "@/components/Search/Search";
  import WorkspacesList from './WorkspacesList.vue';
  import Avatar from "../../app/components/user/Avatar.vue";
  import _ from "lodash";
  import router from "../../Routes";

  export default {
    name: 'Header',
    components: {
        Avatar,
      // Search, 
      WorkspacesList
    },
    data: () => ({
      orgSearch: '',
      menuOrganizations: false,
      config,
      searchCollapse: true,
      notifications: [
        // { text: 'Check out this awesome ticket', icon: 'mdi-tag', color: 'warning' },
        // { text: 'What is the best way to get ...', icon: 'mdi-thumb-up', color: 'success'  },
        // { text: 'This is just a simple notification', icon: 'mdi-flag', color: 'error'  },
        // { text: '12 new orders has arrived today', icon: 'mdi-cart', color: 'primary'  },
      ],
      messages: [
        // { text: 'JH', name: 'Jane Hew', message: 'Hey! How is it going?', time: '09:32', color: 'warning' },
        // { text: 'LB', name: 'Lloyd Brown', message: 'Check out my new Dashboard', time: '10:02', color: 'success'  },
        // { text: 'MW', name: 'Mark Winstein', message: 'I want rearrange the appointment', time: '12:16', color: 'error'  },
        // { text: 'LD', name: 'Liana Dutti', message: 'Good news from sale department', time: '14:56', color: 'primary'  },
      ],
      account: [
        { text: 'Профиль', icon: 'mdi-account', color: 'greyTint', route: 'UserProfile'},
        // { text: 'Tasks', icon: 'mdi-thumb-up', color: 'greyTint'  },
        // { text: 'Messages', icon: 'mdi-flag', color: 'greyTint'  }
      ],
      notificationsBadge: true,
      messageBadge: true
    }),
    watch:{
        orgSearch: function (name) {
            this.onSearch({name})
        }
    },
    computed: {
      ...mapState('layout',
       { drawer: state => state.drawer }
      ),
      ...mapGetters('organization', ['ORGANIZATION']),
      ...mapGetters('user', ['USER_NAME', 'USER_FULL_NAME', 'AVATAR', 'ACTUAL_AVATAR']),
      ...mapGetters('organizationList', ['ORGANIZATIONS', 'IS_FETCHING', 'HAS_LOAD_PREV', 'HAS_LOAD_MORE']),
      ...mapGetters('workspace', ['SHORT_NAME_WORK_SPACE', 'IS_LOAD_WORK_SPACE', 'ORGANIZATION_SHORT_NAME', 'ORGANIZATION_IS_FETCHING', 'ORGANIZATION_HISTORY', 'ORGANIZATION_ID']),
      DRAWER_STATE :{
        get() {
          return this.drawer
        },
      },

      MESSAGES_LIST(){
        return this.messages;
      },

      MESSAGES_COUNT(){
        return this.messages.length;
      },

      NOTIFICATIONS_LIST(){
        if(this.NOTIFICATIONS_COUNT === 0){
          return [{ text: 'Нет уведомлений', icon: 'mdi-bell-off', color: 'warning' }];
        }
        return this.notifications;
      },

      NOTIFICATIONS_COUNT(){
        return this.notifications.length;
      },
      menuOrganizationItems(){
          if(null !== this.ORGANIZATION){
              return [this.ORGANIZATION, ...this.ORGANIZATIONS.filter((o) => o.id !== this.ORGANIZATION.id)]
          }
          return this.ORGANIZATIONS;
      }
    },
    methods: {
        router() {
            return router
        },
      ...mapActions('layout', [ 'TOGGLE_DRAWER']),
      ...mapActions('auth', ['logoutUser']),
      ...mapActions('workspace', ['CHECKOUT_ORGANIZATION']),
      ...mapActions('organizationList', ['LOAD_MORE', 'LOAD_PREV', 'LOAD']),
        onSearch: _.debounce(async function(params){
            await this.LOAD(params);
        }, 1000),
      async onCheckoutOrganization(id){
          this.menuOrganizations = false;
          await this.CHECKOUT_ORGANIZATION(id);
        },
    }
  };
</script>

<style src="./Header.scss" lang="scss"></style>
